<template>
  <div id="app">
    <DxAgenda :agenda="agenda" />
  </div>
</template>

<script>
import DxAgenda from './components/DxAgenda';

export default {
  name: 'App',
  components: {
    DxAgenda
  },
  data () {
    return {
      agenda: {
        subjects:[],
        day_raw:'1970-01-01'
      }
    }
  },
  mounted: function() {

    setTimeout(()=>{
      fetch('./static/agenda21.json', {
        method: 'GET',
        headers: {}
      })
        .then(response => response.json())
        .then(body => {
          console.log(this.agenda);
          this.agenda = body.days[0];
          console.log(this.agenda);
        });
    },2000);

    setTimeout(()=>{
      fetch('./static/agenda.json', {
        method: 'GET',
        headers: {}
      })
        .then(response => response.json())
        .then(body => {
          console.log(this.agenda);
          this.agenda = body.days[0];
          console.log(this.agenda);
        });
    },4000);

    fetch('./static/agenda.json', {
      method: 'GET',
      headers: {}
    })
      .then(response => response.json())
      .then(body => {
        console.log(this.agenda);
        this.agenda = body.days[0];
        console.log(this.agenda);
      });

  }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue